module.exports = __webpack_public_path__ + "static/media/pic1.6bbfab46.jpg";